'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    navDrawerHeaderClassNames: function() {
        return navDrawerHeaderClassNames;
    },
    useNavDrawerHeaderStyles_unstable: function() {
        return useNavDrawerHeaderStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reactdrawer = require("@fluentui/react-drawer");
const navDrawerHeaderClassNames = {
    root: 'fui-NavDrawerHeader'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        jrapky: 0,
        Frg6f3: 0,
        t21cq0: 0,
        B6of3ja: 0,
        B74szlk: "f1r2n0t9",
        B1hrpyx: "f80d8h0",
        Dbcxam: 0,
        rjzwhg: 0,
        Bblux5w: "fesrmp8"
    }
}, {
    d: [
        [
            ".f1r2n0t9{margin:unset;}",
            {
                p: -1
            }
        ],
        ".f80d8h0{-webkit-padding-start:14px;padding-inline-start:14px;}",
        [
            ".fesrmp8{padding-block:5px;}",
            {
                p: -1
            }
        ]
    ]
});
const useNavDrawerHeaderStyles_unstable = (state)=>{
    'use no memo';
    (0, _reactdrawer.useDrawerHeaderStyles_unstable)(state);
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(navDrawerHeaderClassNames.root, styles.root, state.root.className);
    return state;
};
